let firebasePromise = null;

export const loadFirebase = () => {
  if (!firebasePromise) {
    firebasePromise = import( './firestore');
  }
  return firebasePromise;
};

export const getDb = async () => (await loadFirebase()).db;
export const getAuthInstance = async () => (await loadFirebase()).auth;
export const getStorageInstance = async () => (await loadFirebase()).storage;
export const getGoogleProvider = async () => (await loadFirebase()).googleProvider;

export default loadFirebase;
